module.exports = __webpack_public_path__ + "static/media/29FUNOV6.6625cc04.jpg";